export const PROFILE_SECTION = {
	REGISTRATION_DATA: 'registration-data',
	LOGIN_AND_PRIVACY: 'login-and-privacy',
};
